<template>
  <div v-if="currentEchange">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="table-rsesponsive" style="background: white">
            <table class="table table-detail">
              <tbody>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="fa fa-info-circle text-custom-primary"></i>
                        <span class="font-weight-bold"> Titre échange</span>
                      </span>
                      <span>{{ currentEchange.titre }}</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="fa fa-info-circle text-custom-primary"></i>
                        <span class="font-weight-bold"> Type échange</span>
                      </span>
                      <span>
                        {{ currentEchange.type_echange }}
                      </span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="d-flex justify-content-between">
                      <span>
                        <i class="far fa-calendar text-custom-primary"></i>
                        <span class="font-weight-bold"> Date echange</span>
                      </span>
                      <span>
                        {{ currentEchange.date }}
                      </span>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" class="pt-4">
                    <span>
                      <i class="mdi mdi-comment-edit text-custom-primary"></i>
                      <span class="font-weight-bold"> Commentaire</span>
                    </span>
                    <div class="row editor p-0">
                      <div class="col-md-12">
                        <vue-editor
                          id="commentaire"
                          :value="currentEchange.commentaire"
                          :editorToolbar="[[]]"
                          class="fonction-mission"
                          :disabled="true"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end bg-white p-3">
        <div>
          <span class="mr-2"
            ><i class="far fa-user text-custom-primary"></i>
            <span class="font-weight-bold"> Auteur</span></span
          >
          <span> {{ currentEchange.auteur.nom }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
export default {
  props: {
    currentEchange: {
      type: Object,
      required: true,
    },
  },
  components: {
    VueEditor,
  },
};
</script>

<style scoped></style>
